import * as angular from 'angular';
import { GroupCreatorService } from './group-creator.service';
import { allModelsModule } from 'go-modules/models';
import { groupsIndexModule } from 'go-modules/groups-index';
import { createCourseModalModule } from 'go-modules/modals/create-course';

export const groupCreatorModule = angular
	.module('group-creator', [
		allModelsModule,
		groupsIndexModule,
		createCourseModalModule
	])
	.service('GroupCreator', GroupCreatorService)
	.name;
